// Screen `members` — design/screens/Members.dc.html — owner: S10.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { MEMBER_OBJECT_KEY } from '@dataroom/core/member-directory';
import { MembersPage } from '../../../features/access/MembersPage';

export const Route = createFileRoute('/_settings/settings/members')({
  validateSearch: z.object({
    // `fields`, `teams` and `service` are former tabs: old links and bookmarks are redirected below.
    tab: z.enum(['members', 'invites', 'fields', 'teams', 'service']).optional(),
    // The member field a former Fields tab link opened in the field inspector.
    field: z.string().max(63).optional().catch(undefined),
    // ⌘K people hits open a member: the row is scrolled into view and highlighted.
    member: z.string().optional(),
  }),
  beforeLoad: ({ search }) => {
    // Member fields are defined in the object builder of the built-in member object.
    if (search.tab === 'fields')
      throw redirect({
        to: '/settings/objects/$key',
        params: { key: MEMBER_OBJECT_KEY },
        search: { tab: 'fields', ...(search.field ? { field: search.field } : {}) },
        replace: true,
      });
    if (search.tab === 'teams') throw redirect({ to: '/settings/teams', replace: true });
    // Service accounts are members (the list shows them).
    if (search.tab === 'service') throw redirect({ to: '/settings/members', replace: true });
  },
  component: MembersRoute,
});

function MembersRoute() {
  const { tab, member } = Route.useSearch();
  return <MembersPage tab={tab === 'invites' ? 'invites' : 'members'} focusMember={member} />;
}
